export default __webpack_public_path__ + "static/media/harness_of_vengeful_zeal.ccceca42.jpg";